import React, { useMemo } from 'react'
import SendGTAGEvent from '../../utils/sendGTAGEvent';

import FilterButton from '../FilterButton';
import OrderModal from '../OrderModal';

import { Container } from './styles'


interface IOrderProps {
    className?: string;
    isOpen: boolean;
    shouldUseArrow?: boolean;
    onClick: () => void;
    onClose: () => void;
    orderConfigs: {
        key: string;
        itemName: string;
        itemValue: string;
    }[]
    order: any;
    onOrderHandler: (key: string, value: string) => void;
}

const Order: React.FC<IOrderProps> = ({
    isOpen,
    shouldUseArrow,
    className,
    onClose,
    onClick,
    orderConfigs,
    order,
    onOrderHandler
}) => {

    const orderSelected = useMemo(() => {
        const selectedValue = order['order']
        return orderConfigs.find(orderConfig => orderConfig.itemValue === selectedValue)?.itemName
    }, [order, orderConfigs])

    return (
        <Container className={className}>
            <FilterButton
                onClick={() => {
                    onClick()
                    SendGTAGEvent(
                        'botao_ordernar',
                        'Ordenação',
                        'Clicou em botão "Ordenar"')
                }
                }
                shouldUseArrow={shouldUseArrow}
                orderSvg
                isOpen={isOpen}>
                {orderSelected || 'Ordenar'}
            </FilterButton>

            <OrderModal
                isOpen={isOpen}
                orderConfigs={orderConfigs}
                onClose={onClose}
                onOrderHandler={onOrderHandler}
                orderSelected={orderSelected}
            />
        </Container>
    )
}

export default Order